import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { GON_BASIC_Schema } from './GON_BASIC_Schema';

/**
 * 부서 목록 조회 (GetDepLast)
 * - 공통 Utility.getDepLast 사용, CustCd, SearchText
 * - 응답: DepCd, DepNm1~4, DepNmLast, CustCd 등
 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(GON_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Gongjong', 'getDepLast', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Utility.getDepLast, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess || !query.data) return;

    handleQuerySuccess(query.data, {
      onSuccess: (rows) => {
        const mapped = (rows || []).map((r, i) => ({
          no: r.no ?? i + 1,
          depCd: r.DepCd ?? r.depCd ?? '',
          depNm1: r.DepNm1 ?? r.depNm1 ?? '',
          depNm2: r.DepNm2 ?? r.depNm2 ?? '',
          depNm3: r.DepNm3 ?? r.depNm3 ?? '',
          depNm4: r.DepNm4 ?? r.depNm4 ?? '',
          depNmLast: r.DepNmLast ?? r.depNmLast ?? '',
          custCd: r.CustCd ?? r.custCd ?? '',
        }));
        onSuccess?.(mapped);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/**
 * 공정 목록 조회 (GetGonBasicR1, 부서 클릭 시)
 * - Global.urls.Gongjong.getGonBasicR1, DepCd (암호화)
 * - params: { depCd } 전달
 */
export const useSearch2 = (successOptions = {}) => {
  return useSearchMutaion(
    (params) => {
      const apiParams = mapParamsBySchema(
        GON_BASIC_Schema.mapper.search2,
        params || {}
      );
      return apiRequest(
        'post',
        Global.urls.Gongjong.getGonBasicR1,
        apiParams
      );
    },
    successOptions
  );
};

/**
 * 공정 저장 (SaveGonBasicU1)
 * - GongjongCd 비어있으면 INSERT, 있으면 UPDATE
 * - rows: [{ gongjongCd, gongjongNm, depCd, ... }], context: { search, userInfo }
 */
export const useSave1 = (context = {}, options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(
      rows,
      GON_BASIC_Schema.mapper.save1,
      context
    );
    return apiRequest('post1', Global.urls.Gongjong.saveGonBasicU1, payload);
  }, options);
};

/**
 * 공정 삭제 (DeleteGonBasicD1)
 * - rows: [{ gongjongCd, ... }] → payload: [{ GongjongCd }] (암호화)
 */
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, GON_BASIC_Schema.mapper.delete1);
    return apiRequest('post1', Global.urls.Gongjong.deleteGonBasicD1, payload);
  }, options);
};
